
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import lodash from "lodash";
import { pipe } from "fp-ts/lib/function";
import { makeWordPressAjaxRequest } from "@/lib/wordpress/ajax";
import { fold } from "fp-ts/lib/Either";
import * as t from "io-ts";
import {
  ConditionItemGroup,
  ConditionItemGroupV,
  VuetifyShapeForSelect
} from "@/types/conditions";
import NotificationLogger from "@/lib/notifications/notifications";
import {
  getItemGroupsThatApplyToTemplateTypes,
  getVuetifyShapeForDropdownFromConditionItemGroup
} from "@/lib/conditions/conditions";
import Icon from "@/components/UI/Icon.vue";
import MultiselectInput from "@/components/Reusable/CustomInputs/MultiselectInput.vue";
@Component({
  components: { MultiselectInput, Icon }
})
export default class ConditionValuesAutocomplete extends Vue {
  @Prop()
  value: unknown;
  @Prop()
  slug: unknown;

  @Prop({
    default: []
  })
  itemGroups!: ConditionItemGroup[];

  @Prop()
  templateTypes!: string[];

  isLoading = false;
  search: string | null = null;
  loadedItems: ConditionItemGroup[] | false = false;

  get flatItems(): VuetifyShapeForSelect[] {
    const itemsToUse = this.loadedItems || this.itemGroups;

    const itemsToUseThatApplyToTemplateType = getItemGroupsThatApplyToTemplateTypes(
      itemsToUse,
      this.templateTypes
    );

    return getVuetifyShapeForDropdownFromConditionItemGroup(
      itemsToUseThatApplyToTemplateType
    );
  }

  edit(newValue: unknown) {
    this.search = "";
    this.$emit("input", newValue);
  }

  @Watch("search")
  searchChanges() {
    this.debouncedSearchContentInWp();
  }

  @Watch("slug")
  slugChanges() {
    // show original values when changing slug
    this.loadedItems = false;
  }

  setSearch(text: string | null) {
    this.search = text;
  }

  // Average typing speed is a char every 300 ms
  debouncedSearchContentInWp = lodash.debounce(this.searchContentInWp, 600);

  async searchContentInWp() {
    this.isLoading = true;

    pipe(
      await makeWordPressAjaxRequest({
        action: "breakdance_get_condition_values_with_search",
        dataToPost: {
          search: this.search,
          slug: this.slug
        },
        decoder: t.array(ConditionItemGroupV),
        resultKey: "data"
      }),
      fold(
        errors => {
          this.isLoading = false;
          errors.forEach(e => NotificationLogger.log.message(e.msg));
        },
        itemsGroup => {
          this.isLoading = false;
          this.loadedItems = itemsGroup;
        }
      )
    );
  }
}
